{
  "fr": {
    "todo_list": {
      "actions": {
        "add": "Ajouter Liste de Tâches",
        "cancel": "Annuler",
        "delete_todo_list": "Supprimer liste de tâches",
        "edit": "Modifier",
        "new": "Liste de Tâches",
        "save": "Enregistrer",
        "title": "Titre"
      },
      "attributes": {
        "name": "Titre"
      },
      "labels": {
        "assignToLevel": "Attribuer au niveau",
        "createdAt": "Créé à",
        "filter_employee": "Responsable",
        "newTodoList": "Nouvelle liste de tâches",
        "sort": {
          "created_at_asc": "Le plus ancien en premier",
          "created_at_desc": "Le plus récent d'abord",
          "name_lower_asc": "Titre A -> Z",
          "name_lower_desc": "Titre Z -> A"
        }
      },
      "phase_out": {
        "body": "Tâches (ancienne version) prendra fin à la fin de 2026. Migre les tâches dont tu as encore besoin vers Tâches avant le 1er janvier 2027. Tu peux continuer à utiliser et terminer les tâches existantes jusque-là.",
        "title": "Tâches (ancienne version) va disparaître"
      },
      "placeholders": {
        "empty": "Aucune liste de tâches ici"
      },
      "toasts": {
        "create": "Liste de Tâches créée",
        "delete": "Liste de Tâches supprimée",
        "update": "Liste de Tâches mise à jour"
      },
      "validation": {
        "needTitle": "Titre requis"
      }
    }
  }
}
